export function toggleActive() {
   document.querySelectorAll('[data-role="trigger"]').forEach(function(el) {
      el.addEventListener('click', function(event) {
         el.closest('.js-toggle').classList.toggle('active');
      });
   });
}
export function toggleClassActive() {
   document.querySelectorAll('[class*=js-toggle-class-]').forEach(function(el) {
      el.addEventListener('click', function(event) {
          const togglerClassName = Array.from(el.classList).find(cls =>
              cls.startsWith('js-toggle-class-')
          );
          if (togglerClassName) {
              // 2. Suffix extrahieren (z. B. "mein-target")
              const targetSelector = togglerClassName.replace('js-toggle-class-', '');

              // 3. Das Ziel-Element im DOM suchen (wir setzen einen Punkt davor)
              const targetElement = document.querySelector('.' + targetSelector);

              // 4. Prüfen, ob das Ziel existiert und dann "active" toggeln
              if (targetElement) {
                  targetElement.classList.toggle('active');
              } else {
                  console.warn(`Target .${targetSelector} wurde nicht gefunden.`);
              }
          }
      });
   });
}
